import { Box, Divider, Typography } from "@mui/material";
import { ReactComponent as Approved } from "../../../../../icons/icon_files/approved.svg";
import { ReactComponent as Warning } from "../../../../../icons/icon_files/severity_high.svg";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons, logos } from "../../icons/iconExport";

import pluralize from "pluralize";

export function CardMainSection({ entityTypeMetadata }) {
  const { attack_paths, in_critical_assets, breeze_insights } =
    entityTypeMetadata;
  const mainSectionData = [
    {
      icon: attack_paths === 0 ? Approved : Warning,
      iconWidth: "12px",
      text:
        attack_paths === 0
          ? "No Attack Scenarios"
          : `${attack_paths} ${pluralize("Attack Scenario", attack_paths)}`,
      value: attack_paths,
    },
    {
      icon: icons.criticalAssetIcon,
      iconWidth: "13px",
      text:
        in_critical_assets === 0
          ? "None are part of critical assets"
          : in_critical_assets === 1
          ? "1 is part of critical assets"
          : `${in_critical_assets} are part of critical assets`,
      value: in_critical_assets,
    },
    {
      icon: logos.BreezeLogo,
      iconWidth: "14px",
      text: "Breeze's Insights",
      value: breeze_insights,
    },
  ].filter((item) => item.value != null);

  return (
    <Box>
      <Box
        display="flex"
        width="336px"
        flexDirection="column"
        height="92px"
        paddingBottom="12px"
        gap={0.5}
      >
        {mainSectionData.map((item) => (
          <Box
            key={item.text}
            display="flex"
            height="24px"
            gap={0.5}
            alignItems="center"
          >
            <Box
              display="flex"
              width="24px"
              alignItems="center"
              justifyContent="center"
            >
              <SvgToIcon IconLogo={item.icon} width={item.iconWidth} />
            </Box>
            <Typography variant="body2">{item.text}</Typography>
          </Box>
        ))}
      </Box>
      <Divider />
    </Box>
  );
}
